import cx from "classnames";
import { StandardLayout } from "common/layouts/StandardLayout";
import { base } from "lib/styleguide/base.scss";
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./StyleguideFrame.scss";

export class StyleguideFrame extends React.PureComponent {
  render() {
    const { children } = this.props;
    return (
      <StandardLayout>
        <div className={cx(styles.StyleguideFrame, base)}>
          <div className={styles.body}>
            <Nav />
            <div className={styles.content}>{children}</div>
          </div>
        </div>
      </StandardLayout>
    );
  }
}

const StyleguideNavLink = (props) => <NavLink {...props} className={styles.navItem} activeClassName={styles.active} />;

const Nav = () => (
  <div className={styles.navigation}>
    <StyleguideNavLink to="/styleguide" exact>
      Typography
    </StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/colors">Colors</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/buttons">Buttons</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/lists">Lists</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/modals">Modals</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/popovers">Popovers</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/tooltips">Tooltips</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/hero_component">Hero Component</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/login">Login</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/navbar">Navigation</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/forms">Forms</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/time">Time</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/widgets">Widgets</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/icons">Icons</StyleguideNavLink>
    <StyleguideNavLink to="/styleguide/units">Units</StyleguideNavLink>
  </div>
);
